const HomeAbout = () => {
   return (
      <>
         <section className="about__area pb-200 pt-100">
            <div className="tw-container tw-mx-auto">
               <div className="tw-flex tw-flex-wrap tw--mx-3">
                  <div className="tw-w-full tw-px-3 lg:tw-w-1/2">
                     <div className="about__thumb m-img">
                        <img src="assets/img/about/about-1.jpg" alt="" />
                     </div>
                  </div>
                  <div className="tw-w-full tw-px-3 lg:tw-w-5/12 lg:tw-ml-[8.3333%]">
                     <div className="about__content">
                        <div className="section__title mb-25">
                           <span>Who we are</span>
                           <h2>Your Trusted Partner in Digital Innovation</h2>
                        </div>
                        <p>
                           At Harsoft, we are passionate about leveraging technology to drive innovation, empower businesses, and enhance the digital experience for users around the globe. With a team boasting over 20 years of collective experience and expertise in a wide range of services, we are committed to delivering cutting-edge solutions that exceed expectations and drive tangible results for our clients.
                        </p>
                     </div>
                  </div>
               </div>
            </div>
         </section>
      </>
   );
};

export default HomeAbout;
